import { AccessTypeTag } from './AccessTypeTag';
import { camelCase } from 'lodash';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ObjectPermissionsTag } from './ObjectPermissionsTag';
import React from 'react';
import { SalesforceLogo } from '@ui/icons';
import { Space, Tooltip } from 'antd';
export const objectNameColumn = {
    dataIndex: 'objectName',
    fixed: 'left',
    key: 'objectName',
    title: COPY_SPECIFIC.OBJECT
};
export function getColumns(dynamicColumns) {
    const columns = dynamicColumns.map((access) => ({
        dataIndex: 'accessObjects',
        key: access.accessId,
        render: (accessObjects) => {
            var _a, _b;
            const accessPermissions = (_b = (_a = accessObjects.find((obj) => obj.accessId === access.accessId)) === null || _a === void 0 ? void 0 : _a.permissions) !== null && _b !== void 0 ? _b : [];
            return (React.createElement(ObjectPermissionsTag, { permissions: accessPermissions.reduce((acc, permission) => (Object.assign(Object.assign({}, acc), { [camelCase(permission)]: '' })), {}) }));
        },
        title: React.createElement(Space, { direction: 'vertical' },
            React.createElement(Space, null,
                access.accessName,
                React.createElement(Tooltip, { placement: 'bottom', title: COPY_SPECIFIC.VIEW_IN_SALESFORCE },
                    React.createElement("a", { href: access.sourceUrl, id: access.accessId, style: { display: 'flex' }, target: '_blank' },
                        React.createElement(SalesforceLogo, { title: '' })))),
            React.createElement(AccessTypeTag, { accessType: access.accessType }))
    }));
    return [
        objectNameColumn,
        ...columns
    ];
}
